import { apiClient } from './client'

export type ExerciseTrackerInstruction = {
  id: string
  key: string
  title: string
  instructionsMarkdown: string
  createdAt: string
  updatedAt?: string | null
}

export type ExerciseTrackerInstructionPayload = {
  key: string
  title: string
  instructionsMarkdown: string
}

export async function getExerciseTrackerInstructions(): Promise<ExerciseTrackerInstruction[]> {
  const { data } = await apiClient.get<ExerciseTrackerInstruction[]>('/api/admin/exercise-tracker-instructions')
  return data
}

export async function getExerciseTrackerInstruction(key: string): Promise<ExerciseTrackerInstruction> {
  const { data } = await apiClient.get<ExerciseTrackerInstruction>(`/api/admin/exercise-tracker-instructions/${key}`)
  return data
}

export async function createExerciseTrackerInstruction(
  payload: ExerciseTrackerInstructionPayload
): Promise<ExerciseTrackerInstruction> {
  const { data } = await apiClient.post<ExerciseTrackerInstruction>('/api/admin/exercise-tracker-instructions', payload)
  return data
}

export async function updateExerciseTrackerInstruction(
  id: string,
  payload: ExerciseTrackerInstructionPayload
): Promise<ExerciseTrackerInstruction> {
  const { data } = await apiClient.put<ExerciseTrackerInstruction>(`/api/admin/exercise-tracker-instructions/${id}`, payload)
  return data
}

export async function deleteExerciseTrackerInstruction(id: string): Promise<void> {
  await apiClient.delete(`/api/admin/exercise-tracker-instructions/${id}`)
}
